import { render, staticRenderFns } from "./AAsignacionTablartxs.vue?vue&type=template&id=cc9a2a18"
import script from "./AAsignacionTablartxs.vue?vue&type=script&lang=js"
export * from "./AAsignacionTablartxs.vue?vue&type=script&lang=js"
import style0 from "./AAsignacionTablartxs.vue?vue&type=style&index=0&id=cc9a2a18&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports